import createFetchActions from './createFetchActions';

const fetchValidationActions = createFetchActions('FETCH_VALIDATION');

export { fetchValidationActions };
